import Vue from "vue";

import {
    Alert,
    Autocomplete,
    Badge,
    Breadcrumb,
    BreadcrumbItem,
    Button,
    Icon,
    Card,
    Carousel,
    CarouselItem,
    Checkbox,
    CheckboxGroup,
    Col,
    Container,
    DatePicker,
    Dialog,
    Form,
    FormItem,
    Input,
    Loading,
    Main,
    Menu,
    Message,
    MessageBox,
    MenuItem,
    Notification,
    Option,
    OptionGroup,
    Pagination,
    Progress,
    Radio,
    RadioButton,
    RadioGroup,
    Row,
    Select,
    Step,
    Steps,
    Submenu,
    TabPane,
    Table,
    TableColumn,
    Tabs,
    Tag,
    Tooltip
} from "element-ui";

Vue.use(Alert);
Vue.use(Autocomplete);
Vue.use(Badge);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Button);
Vue.use(Card);
Vue.use(Icon);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Col);
Vue.use(Container);
Vue.use(DatePicker);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Main);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Pagination);
Vue.use(Progress);
Vue.use(Radio);
Vue.use(RadioButton);
Vue.use(RadioGroup);
Vue.use(Row);
Vue.use(Select);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Submenu);
Vue.use(TabPane);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tabs);
Vue.use(Tag);
Vue.use(Tooltip);

Vue.component(Message);
Vue.component(Notification);
Vue.component(MessageBox);

Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;
